import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _typeof from '@babel/runtime/helpers/typeof';
import { CONTACT_TYPES } from './Const.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var matchInAssets = function matchInAssets() {
  var assets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var term = arguments.length > 1 ? arguments[1] : undefined;
  var matched = [];
  assets.some(function (asset) {
    var _asset$vehicle;
    if ((asset === null || asset === void 0 ? void 0 : (_asset$vehicle = asset.vehicle) === null || _asset$vehicle === void 0 ? void 0 : _asset$vehicle.vin) === term) {
      matched.push('vin');
      return true;
    }
    return false;
  });
  return matched;
};
var matchInOrders = function matchInOrders() {
  var orders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var term = arguments.length > 1 ? arguments[1] : undefined;
  var matched = [];
  orders.some(function (order) {
    if ((order === null || order === void 0 ? void 0 : order.order_number) === term) {
      matched.push('order_number');
      return true;
    }
    return false;
  });
  return matched;
};
var matchInEmail = function matchInEmail() {
  var emails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var term = arguments.length > 1 ? arguments[1] : undefined;
  var matched = false;
  emails.some(function (ad) {
    if (ad.email_address === term) {
      matched = true;
      return true;
    }
    return false;
  });
  return matched;
};
var matchInAccount = function matchInAccount() {
  var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var term = arguments.length > 1 ? arguments[1] : undefined;
  var matched = [];
  if (!acc) return matched;
  Object.keys(acc).some(function (attr) {
    if (['string', 'number'].includes(_typeof(attr)) && acc[attr] === term || attr === 'email_book' && matchInEmail(acc[attr], term)) {
      matched.push(attr);
      return true;
    }
    return false;
  });
  return matched;
};
var matchInContacts = function matchInContacts(contacts, term) {
  var matched = [];
  contacts.forEach(function (con, i) {
    matchInAccount(con, term).forEach(function (item) {
      matched.push("".concat(item, "_").concat(i));
    });
  });
  return matched;
};
var isContact = function isContact() {
  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var match = false;
  types.some(function (t) {
    if (CONTACT_TYPES.includes(t)) {
      match = true;
      return true;
    }
    return false;
  });
  return match;
};
var getAccEmail = function getAccEmail(_ref) {
  var account = _ref.account;
  var email;
  account.email_book.some(function (em) {
    if (em.is_active) {
      email = em.email_address;
      return em.email_address;
    }
    return false;
  });
  if (!email && account.email_book.length) return account.email_book[0].email_address;
  return email;
};
var getAccDisplayByType = function getAccDisplayByType(_ref2) {
  var account = _ref2.account;
  return (account === null || account === void 0 ? void 0 : account.account_type) === 'PERSON' ? account.full_name || account.first_name || account.last_name : account.company_name;
};
var getAccDisplayByName = function getAccDisplayByName(_ref3, matchItems, term) {
  var account = _ref3.account;
  if (matchItems.includes('first_name') || matchItems.includes('last_name')) return account.full_name;
  return term;
};
var getVIN = function getVIN(result) {
  return result.assets[0].vehicle.vin;
};

// look for contact details, fall back on account
var getContactDetails = function getContactDetails(result, id) {
  var _result$contacts$id, _result$contacts$id2, _result$contacts$id3;
  return ((_result$contacts$id = result.contacts[id]) === null || _result$contacts$id === void 0 ? void 0 : _result$contacts$id.full_name) || ((_result$contacts$id2 = result.contacts[id]) === null || _result$contacts$id2 === void 0 ? void 0 : _result$contacts$id2.first_name) || ((_result$contacts$id3 = result.contacts[id]) === null || _result$contacts$id3 === void 0 ? void 0 : _result$contacts$id3.last_name) || getAccDisplayByType(result);
};
var getNameOrEmail = function getNameOrEmail(result) {
  return getAccDisplayByType(result) || getAccEmail(result);
};

// from each result set, we have to pick one label and one identifier to show in the list
var getOptionFromSearchResult = function getOptionFromSearchResult(result, matchCount, matchItems, term, identifierList) {
  var listOption = {
    account_id: result.account.account_id,
    data: _objectSpread({}, result.account)
  };
  if (matchCount === 1) {
    var identifier;
    var matchedValue;
    // find which contact matched
    var id = parseInt(matchItems[0].split('_')[2], 10);
    // exactly 1 contact has matched
    if (isContact(result === null || result === void 0 ? void 0 : result.matched_item)) {
      // matched on email, so identifier will be name of selected contact
      if (matchItems[0].startsWith('email_book')) {
        identifier = getContactDetails(result, id);
        // if identifier already exists, use account level details
        if (identifierList.includes(identifier)) {
          identifier = getAccDisplayByType(result);
        }
      } else {
        var _result$contacts$id4, _result$contacts$id4$, _result$contacts$id4$2;
        // matched on non-email, so identifier will be first email of matched contact
        identifier = ((_result$contacts$id4 = result.contacts[id]) === null || _result$contacts$id4 === void 0 ? void 0 : (_result$contacts$id4$ = _result$contacts$id4.email_book) === null || _result$contacts$id4$ === void 0 ? void 0 : (_result$contacts$id4$2 = _result$contacts$id4$[0]) === null || _result$contacts$id4$2 === void 0 ? void 0 : _result$contacts$id4$2.email_address) || getAccEmail(result);
      }
      var _op = _objectSpread(_objectSpread({}, listOption), {}, {
        label: getAccDisplayByName(result, matchItems, term),
        value: identifier
      });
      return _op;
    }
    // exactly 1 match, non contact
    // as above, if matched term is email, identifier is something else and vice versa
    if (matchItems[0].startsWith('vin')) {
      matchedValue = getVIN(result);
      identifier = getAccEmail(result);
    } else if (matchItems[0].startsWith('email_book')) {
      identifier = getAccDisplayByType(result);
    } else {
      identifier = getAccEmail(result);
    }
    var op = _objectSpread(_objectSpread({}, listOption), {}, {
      label: getAccDisplayByName(result, matchItems, term),
      value: identifier,
      matchedValue: matchedValue
    });
    return op;
  }
  if (matchCount === 0) {
    // 0 exact matches, show account name + email
    var _op2 = _objectSpread(_objectSpread({}, listOption), {}, {
      label: getAccDisplayByType(result),
      value: getAccEmail(result)
    });
    return _op2;
  }
  if (matchCount > 1) {
    // multiple matches, show acc details
    var _op3 = _objectSpread(_objectSpread({}, listOption), {}, {
      label: getAccDisplayByName(result, matchItems, term),
      value: getNameOrEmail(result)
    });
    return _op3;
  }
  return {};
};
var transformTypeahead = function transformTypeahead() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var term = arguments.length > 1 ? arguments[1] : undefined;
  var typeaheadOptions = [];
  var identifierList = [];
  data === null || data === void 0 ? void 0 : data.forEach(function (dataset) {
    var uid = {};
    uid.account = matchInAccount(dataset.account, term);
    uid.orders = matchInOrders(dataset.orders, term);
    uid.assets = matchInAssets(dataset.assets, term);
    uid.contacts = matchInContacts(dataset.contacts, term);
    var matchCount = uid.account.length + uid.orders.length + uid.assets.length + uid.contacts.length;
    var matchItems = [].concat(_toConsumableArray(uid.account), _toConsumableArray(uid.orders), _toConsumableArray(uid.assets), _toConsumableArray(uid.contacts));
    var opt = getOptionFromSearchResult(dataset, matchCount, matchItems, term, identifierList);
    identifierList.push(opt.value);
    typeaheadOptions.push(opt);
  });
  if (!(typeaheadOptions !== null && typeaheadOptions !== void 0 && typeaheadOptions.length)) return null;
  return [{
    data: typeaheadOptions
  }];
};
var transformRecentSearches = function transformRecentSearches(data, recent) {
  if (!(data !== null && data !== void 0 && data.length)) return null;
  var results = {
    type: recent,
    data: data.reverse().map(function (op) {
      return {
        label: op
      };
    })
  };
  return [results];
};
var Transform = {
  typeahead: transformTypeahead,
  recent: transformRecentSearches
};

export { Transform as default };
